export default {
  businessLogisticsCompanyFreight: {
    header: {
      templateName: '模板名称',
      businessName: '业务名称',
      applicableWarehouse: '适用仓库'
    },
    table: {
      templateName: '模板名称',
      ApplicableLogistics: '适用物流业务',
      applicableWarehouse: '适用仓库',
    },
    // 新增页面
  Add: {
    essentialInformation: '基本信息',
    templateName: '模板名称',
    description: '描述',
    costPriority: '费用计算方式优先级',
    billingByWeightIsPreferred: '按重量计费优先',
    billingByVolumePriority: '按体积计费优先',
    setConversionFormula: '设置体积重量换算公式',
    receivingAreaCostStandard: '收货区域费用标准',
    addedStandardCharge: '添加标准费用',
    area: '区域',
    editArea: '编辑区域',
    singleQuantity: '单量 / 月',
    unlimited: '无限',
    parcelWeightRange: '包裹重量范围（含首重）',
    chargeMode: '计费方式',
    cost: '费用',
    dollar: '元',
    increaseRange: '增加范围',
    addLine: '添加行',
    deleteRow: '删除行',
    claimStandard: '理赔标准',
    damagePriceStandard: '破损价格标准:',
    priceStandardForLostItems: '丢件价格标准:',
    freeOdds: '免赔率',
    templateApplicableLogistics: '模板适用物流业务',
    selectBusiness: '选择业务',
    businessName: '业务名称',
    affiliatedLogisticsProvider: '所属物流商',
    templateApplicableWarehouse: '模板适用仓库',
    selectWarehouse: '选择仓库',
    warehouseCoding: '仓库编码',
    warehouseName: '仓库名称',
    warehouseAddress: '仓库地址',
    setVolume: '设置体积',
    volumeFormula: '体积重量计算公式 = 长(cm) × 宽(cm) × 高(cm) /',
    templateNameText: '请输入模板名称',
    LogisticsName: '物流商名称',
    callbackErrorText: '请输入0-100正整数值',
    singleQtyErrMsg: '单量',
    weightRange: '重量范围',
    msgWarning1: '请选择物流业务',
    left: '左',
    leftText: '必须小于右',
    right: '右',
    rightText1: '输入不正确',
    rightText2: '必须大于左',
    msgWarning2: '请先选择一个物流业务',
  },
  }
};
